import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-VerticalArrowShape",
  "use": "svg-icon-VerticalArrowShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-VerticalArrowShape\"><path d=\"M8 11.727c-.412 0-.665-.155-.998-.487L1.256 5.494a.875.875 0 1 1 1.238-1.238L8 9.763l5.506-5.507a.875.875 0 1 1 1.238 1.238l-5.726 5.725c-.34.34-.606.508-1.018.508z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol